import moment from 'moment'
import React, { useEffect, useState } from 'react'
import { IDriverManifestsTrip } from 'src/types/driver-manifests'
import {
  cancelledTripsStatusesDashboard,
  completedTripStatusesDashboard,
  TripStatuses
} from 'src/constants/trip-statuses'
import Warning from '../icons/auth/Warning'

interface IDriverManifestsTripItemProps {
  trip: IDriverManifestsTrip
  selectedTrip: IDriverManifestsTrip | null
  setSelectedTrip: (value: IDriverManifestsTrip) => void
}

const DriverManifestsTripItem: React.FC<IDriverManifestsTripItemProps> = props => {
  const { trip, selectedTrip, setSelectedTrip } = props
  const [isSelected, setIsSelected] = useState<boolean>(false)

  useEffect(() => {
    if (selectedTrip && selectedTrip.id === trip.id) {
      setIsSelected(true)
    } else {
      setIsSelected(false)
    }
  }, [selectedTrip])

  const getLastStatusTime = () => {
    const lastStatus = trip.statuses[0]
    const statusTime = moment(lastStatus.createdAt).format('hh:mm A')
    return `${statusTime}`
  }

  const countryList = new Set(['Philippines', 'United States', 'USA'])

  const removeCountrySuffix = (input: string): string => {
    const parts = input.split(',').map(part => part.trim())
    const lastPart = parts[parts.length - 1]

    if (countryList.has(lastPart)) {
      return parts.slice(0, -1).join(', ')
    }

    return input
  }

  const getStatusColor = () => {
    if (trip.hasIssue) {
      if (
        trip.notificationMessage.toLowerCase().includes('vehicle') ||
        trip.lastStatus === TripStatuses.NO_SHOW_RIDER
      ) {
        return 'dm-tag-red'
      } else if (trip.notificationMessage.toLowerCase().includes('behind')) {
        return 'dm-tag-orange'
      } else if (cancelledTripsStatusesDashboard.includes(trip.lastStatus)) {
        return 'dm-tag-gray'
      } else {
        return 'dm-tag-red'
      }
    } else if (cancelledTripsStatusesDashboard.includes(trip.lastStatus)) {
      return 'dm-tag-gray'
    } else {
      return 'dm-tag-green'
    }
  }

  const getStatusBorder = () => {
    if (trip.hasIssue) {
      if (
        trip.notificationMessage.toLowerCase().includes('vehicle') ||
        trip.lastStatus === TripStatuses.NO_SHOW_RIDER
      ) {
        return 'dm-side-border-red'
      } else if (trip.notificationMessage.toLowerCase().includes('behind')) {
        return 'dm-side-border-orange'
      } else if (cancelledTripsStatusesDashboard.includes(trip.lastStatus)) {
        return 'dm-side-border-gray'
      } else {
        return 'dm-side-border-red'
      }
    } else if (cancelledTripsStatusesDashboard.includes(trip.lastStatus)) {
      return 'dm-side-border-gray'
    } else {
      return 'dm-side-border-green'
    }
  }

  const getStatusText = () => {
    if (trip.hasIssue) {
      if (trip.notificationMessage.toLowerCase().includes('vehicle')) {
        return 'Vehicle Issue'
      } else if (trip.notificationMessage.toLowerCase().includes('behind')) {
        return 'Late'
      } else if (trip.lastStatus === TripStatuses.NO_SHOW_RIDER) {
        return 'No Show'
      } else if (cancelledTripsStatusesDashboard.includes(trip.lastStatus)) {
        return 'Cancelled'
      } else {
        return 'Has Issue'
      }
    } else if (cancelledTripsStatusesDashboard.includes(trip.lastStatus)) {
      return 'Cancelled'
    } else if (completedTripStatusesDashboard.includes(trip.lastStatus)) {
      return 'Completed'
    } else {
      return 'On Time'
    }
  }

  return (
    <div
      className={
        isSelected
          ? 'dm-trip-section-item dm-selected-trip ' + getStatusBorder()
          : 'dm-trip-section-item ' + getStatusBorder()
      }
      role='button'
      aria-label='Select trip'
      onClick={() => setSelectedTrip(trip)}
    >
      <div className='dm-trip-header'>
        <div>
          {trip.rider.firstName} {trip.rider.lastName}
        </div>
        <div className={getStatusColor()}>{getStatusText()}</div>
      </div>
      <div className='dm-trip-subtitle'>
        <img className='dm-icon' src='/images/clock.png' alt='Clock icon' />
        <div className='flex items-center pl1'>
          {moment(trip.scheduledPickupTime).isValid()
            ? moment(trip.scheduledPickupTime).format('hh:mm A')
            : 'Not Available'}{' '}
          -{' '}
          {moment(trip.scheduledDropoffTime).isValid()
            ? moment(trip.scheduledDropoffTime).format('hh:mm A')
            : 'Not Available'}
        </div>
      </div>
      <div className='dm-trip-subtitle'>
        <img className='dm-icon' src='/images/map-pin.png' alt='Map Pin Icon' />
        <div className='flex items-center pl1'>{removeCountrySuffix(trip.pickupLocation.fullAddress)}</div>
      </div>
      <div className='dm-trip-subtitle'>
        <img className='dm-icon' src='/images/map-pin.png' alt='Map Pin Icon' />
        <div className='flex items-center pl1'>{removeCountrySuffix(trip.dropoffLocation.fullAddress)}</div>
      </div>
      <div className='dm-trip-footer'>
        Status updated: {getLastStatusTime()}
        {trip.hasIssue && (
          <div className='dm-warning-indicator'>
            <Warning className='svg-yellow' />
            <div className='pl1'>Requires Attention</div>
          </div>
        )}
      </div>
    </div>
  )
}

export default DriverManifestsTripItem



// WEBPACK FOOTER //
// ./src/components/driver-manifests/DriverManifestsTripItem.tsx